export default "assets/images/icons/search-66ce1ef9.svg";